export default {"src":"/_next/static/media/plr.6c73beb1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};